import { Row, Col, Container, Card, Form, Button, Spinner, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getRates, saveExchangeRate } from "../../redux/slices/account.service";
import Swal from "sweetalert2";
import formatCurrency from "../../utils/currencyFormmter";

const ExchangeRates = () => {

    const dispatch = useDispatch()
    const isLoading = useRef(false);

    const initialState = {
        rates: [],
        payload: {}
    }

    const [loading, setLoading] = useState(false)
    const [show_edit, setShowEdit] = useState(false)
    const [state, setState] = useState(initialState)
    const [editMode, setEditMode] = useState(false)

    useEffect(() => {
        if(isLoading.current) return;
        loadExchangeRates()
        isLoading.current = true;
    }, [])
 

    const loadExchangeRates = () =>  {
        dispatch(getRates())
        .then((response) => {
            if(response.payload?.data) {
                setState({...state, rates: response.payload?.data})
            }
        })
    }

    const handleRateUpdate = () => {
        Swal.fire({
            icon: 'warning',
            text: `Are you sure you want to apply changes?`,
            showCancelButton: true,
            confirmButtonText: 'Yes, Proceed',
            cancelButtonText: 'No, Cancel'
        })
        .then((result) => {
            if (result.isConfirmed) {
                setLoading(true)
                dispatch(saveExchangeRate(state.payload))
                .then((response) => {
                    if(response.payload?.success && response.payload?.success === true) {
                        Swal.fire({
                            icon: 'success',
                            text: `Currency rate updated successfully.`,
                        })
                        loadExchangeRates()
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: response.payload?.message ?? `Failed to update currency rate.`,
                        })
                    }
                })
                .finally(() => setLoading(false))
            }
        })
    }
 
    return (
        <Layout title="Exchange Rates">
            <Container className="mt-4 px-4 px-lg-4 px-sm-2 px-md-2 mb-4">
                <div className="mt-4">
                    <Card className="border-0 shadow-sm mt-5">
                        <Card.Header className="d-flex align-items-center justify-content-between bg-white border-0">
                            <h5>Exchange Rate</h5>
                            <button 
                                type="button" 
                                className="btn-plain text-primary text-sm bg---secondary rounded-1 font-bold px-3 py-2"
                                onClick={ () => setEditMode(!editMode)}
                            >
                                Edit Details
                            </button>
                        </Card.Header>
                        <Card.Body className="table-responsive-sm">
                           <div className="table-responsive border rounded-1">
                            <table className="table table-borderless table-sm">
                                <thead className="border-bottom">
                                    <tr>
                                        <th>Currency</th>
                                        <th>Rate</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.rates && (
                                            state.rates.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.currency.toUpperCase()}</td>
                                                    <td>
                                                        {formatCurrency(item.rate).with_currency}
                                                    </td>
                                                    <td>
                                                        {
                                                            editMode && (
                                                                <div className="input-group w-50">
                                                                    <input 
                                                                        className="form-control form-control-sm"
                                                                        type="number" 
                                                                        placeholder={item.currency} 
                                                                        min={0}
                                                                        rate_id={item.id}
                                                                        value={item.rate}
                                                                        onChange={(e) => {
                                                                            const updatedCharges = state.rates //.filter(s => s.id === item.id)[0];
                                                                            updatedCharges[index].rate = e.target.value; 
                                                                            setState((prevState) => ({
                                                                                ...prevState,
                                                                                charges: updatedCharges,
                                                                                payload: { 
                                                                                    ...prevState.payload, 
                                                                                    amount: e.target.value,
                                                                                    rate_id:  item.id
                                                                                }
                                                                            }));
                                                                        }}
                                                                    />
                                                                    <div className="input-group-appennd">
                                                                        <Button 
                                                                            variant="primary" 
                                                                            type="button"
                                                                            size="sm"
                                                                            className="input-group-text"
                                                                            onClick={handleRateUpdate}
                                                                            disabled={item.id !== state.payload.rate_id}
                                                                        > Save <Spinner animation={ loading && item.id === state.payload.rate_id  ? "border" : null} role="status" size="sm"></Spinner>
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                    }
                                </tbody>
                            </table>
                           </div>
                        </Card.Body>
                    </Card>
                </div>
                <Modal 
                    show={show_edit}
                    onHide={ () => setShowEdit(!show_edit)}
                >
                    <Modal.Header closeButton className="p-2">
                        <h6 className="modal-title">Exchange Rates</h6>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row className="mb-2">
                                {
                                    state.charges && (
                                        state.charges.map((item, index) => (
                                            <Form.Group className="mb-3" as={Col} md={6} key={index}>
                                                <Form.Label>{item.currency.toUpperCase()}</Form.Label>
                                                <Form.Control 
                                                    type="number" 
                                                    placeholder={item.currency} 
                                                    min={0}
                                                    name={item.currency}
                                                    value={item.rate}
                                                    onChange={(e) => {
                                                        const updatedCharges = [...state.charges];
                                                        updatedCharges[index].rate = e.target.value; 
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            charges: updatedCharges,
                                                            payload: { 
                                                                ...prevState.payload, 
                                                                [item.currency]: e.target.value
                                                            }
                                                        }));
                                                    }}
                                                />
                                            </Form.Group>
                                        ))
                                    )
                                }
                            </Row>
                            <div className="d-grid gap-2">
                                <Button 
                                    variant="primary" 
                                    type="button"
                                    className="d-block"
                                    onClick={handleRateUpdate}
                                > Save Changes <Spinner animation={ loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            </Container>
        </Layout>
    );
}

export default ExchangeRates;